var map = {
	"./AIvoicebot.png": 53747,
	"./Away.png": 45090,
	"./Away_old.png": 26160,
	"./Busy.png": 64403,
	"./CHATBOT_LOGO.png": 11981,
	"./Offline.png": 62379,
	"./OnThePhone.png": 26744,
	"./Online.png": 71157,
	"./bad.png": 90899,
	"./copy_close.png": 72390,
	"./copy_open.png": 75988,
	"./dis_save_info.png": 83705,
	"./exclamation.png": 91777,
	"./footer_btn1.png": 73191,
	"./footer_btn2.png": 4716,
	"./footer_btn3.png": 87605,
	"./footer_btn4.png": 13306,
	"./good.png": 65315,
	"./heart-white-current.png": 90102,
	"./heart-white.png": 15550,
	"./heart_2.png": 66757,
	"./knowledge_save.png": 78456,
	"./manual_chat_questioner.png": 40739,
	"./manual_chat_questioner_bk.png": 52573,
	"./mic.png": 68155,
	"./monster.png": 57688,
	"./moppy1.png": 53750,
	"./notInCharge.png": 26928,
	"./op_qu_bg.png": 26432,
	"./operator.png": 69860,
	"./operatorPi.png": 91917,
	"./pin.png": 81503,
	"./redmine.png": 8254,
	"./save.png": 93475,
	"./search_user.png": 48180,
	"./send.png": 64806,
	"./settings.png": 87979,
	"./splitLine.png": 70656,
	"./timeline.png": 55817,
	"./user_logo.png": 77651,
	"./user_logo_bk.png": 91405,
	"./user_logo_bk2.png": 15563,
	"./watson.png": 68192
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92183;